import React, { useState, useCallback, useRef, useEffect } from "react";
import { GoogleMap, Marker, useJsApiLoader } from "@react-google-maps/api";
import store_open from "../../assest/icons/store_open.png";

const containerStyle = {
  width: "100%",
  height: "400px", // 👈 small map for register
};

const libraries = ["places"];

function GoogleMapsView({ lat, lng, getAddress }) {
  const { isLoaded } = useJsApiLoader({
    id: "google-map-script",
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
    libraries,
  });

  const mapRef = useRef(null);

  const [selectedLocation, setSelectedLocation] = useState(null);
  const [currentLocation, setCurrentLocation] = useState(null);
  const [address, setAddress] = useState("");

  // ✅ default center
  const center = {
    lat: lat || 5.5571096,
    lng: lng || -0.2012376,
  };

  // ✅ Reverse geocode
  const getAddressFromLatLng = async (lat, lng) => {
    const geocoder = new window.google.maps.Geocoder();

    try {
      const result = await geocoder.geocode({
        location: { lat, lng },
      });

      if (result.results[0]) {
        const formattedAddress = result.results[0].formatted_address;

        setAddress(formattedAddress);

        // 🔥 send to parent (Formik)
        if (getAddress) {
          getAddress(formattedAddress, { lat, lng });
        }
      }
    } catch (error) {
      console.error("Geocoding error:", error);
    }
  };

  // ✅ map load
  const onLoad = useCallback((map) => {
    mapRef.current = map;

    // current location button
    const locationButtonDiv = document.createElement("div");

    locationButtonDiv.innerHTML = `
      <div style="background:white;padding:8px;border-radius:8px;cursor:pointer">
        📍
      </div>
    `;

    map.controls[window.google.maps.ControlPosition.TOP_RIGHT].push(
      locationButtonDiv,
    );

    locationButtonDiv.addEventListener("click", () => {
      navigator.geolocation.getCurrentPosition((position) => {
        const userLocation = {
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        };

        setCurrentLocation(userLocation);
        map.panTo(userLocation);
        setSelectedLocation(userLocation);
        
        if (getAddress) {
          getAddress("", userLocation);
        }
        getAddressFromLatLng(userLocation.lat, userLocation.lng);
      });
    });

    // ✅ click event
    map.addListener("click", async (e) => {
      const latLng = {
        lat: e.latLng.lat(),
        lng: e.latLng.lng(),
      };

      setSelectedLocation(latLng);

      // ✅ ALWAYS send lat/lng (even if geocoder fails)
      if (getAddress) {
        getAddress("", latLng);
      }

      // try to fetch address (optional)
      await getAddressFromLatLng(latLng.lat, latLng.lng);
    });
  }, []);

  const onUnmount = () => {
    mapRef.current = null;
  };

  // ✅ move map when city changes
  useEffect(() => {
    if (lat && lng && mapRef.current) {
      const newCenter = { lat, lng };
      mapRef.current.panTo(newCenter);
      setSelectedLocation(newCenter);
    }
  }, [lat, lng]);

  if (!isLoaded) return null;

  return (
    <div>
      <GoogleMap
        mapContainerStyle={containerStyle}
        center={center}
        zoom={12}
        onLoad={onLoad}
        onUnmount={onUnmount}
      >
        {/* selected marker */}
        {selectedLocation && (
          <Marker
            position={selectedLocation}
            icon={{
              path: window.google.maps.SymbolPath.CIRCLE,
              scale: 8,
              fillColor: "red",
              fillOpacity: 1,
              strokeWeight: 2,
              strokeColor: "white",
            }}
          />
        )}

        {/* current location */}
        {currentLocation && (
          <Marker
            position={currentLocation}
            icon={{
              path: window.google.maps.SymbolPath.CIRCLE,
              scale: 8,
              fillColor: "blue",
              fillOpacity: 1,
              strokeWeight: 2,
              strokeColor: "white",
            }}
          />
        )}
      </GoogleMap>

      {/* optional debug */}
      {/* {selectedLocation && (
        <div style={{ marginTop: 10 }}>
          <p>
            <b>Lat:</b> {selectedLocation.lat}
          </p>
          <p>
            <b>Lng:</b> {selectedLocation.lng}
          </p>
          <p>
            <b>Address:</b> {address}
          </p>
        </div>
      )} */}
    </div>
  );
}

export default React.memo(GoogleMapsView);
